function overlayOffcanvas (identifier: string, aside: string, list_button: string[], list_container: string[]) {
  let elemen1 = document.getElementById(identifier)
  let elemen2 = document.getElementById(aside)

  elemen1?.classList.remove('drawer-overlay')
  elemen2?.classList.remove('drawer', 'drawer-start', 'drawer-on')

  for (let button of list_button) {
    let element = document.getElementById(button)
    element?.classList.remove('drawer-on')
  }

  for (let container of list_container) {
    let element = document.getElementById(container)
    element?.classList.remove('active')
  }
}

function overlayDark (identifier: string, list_button: string[], list_container: string[]) {
  let element = document.getElementById(identifier)
  element?.classList.remove('menu-overlay')

  for (let button of list_button) {
    let element = document.getElementById(button)
    element?.classList.remove('active')
  }

  for (let container of list_container) {
    let element = document.getElementById(container)
    element?.classList.remove('show')
  }
}

function overlayTransparent (identifier: string, list_button: string[], list_container: string[]) {
  let element = document.getElementById(identifier)
  element?.classList.remove('menu-overlay-transparent')

  for (let button of list_button) {
    let element = document.getElementById(button)
    element?.classList.remove('show')
  }

  for (let container of list_container) {
    let element = document.getElementById(container)
    element?.classList.remove('show')
  }
}

export { overlayOffcanvas, overlayDark, overlayTransparent }
